<template>
  <div>
    <!-- mini version -->
    <div v-if="variant === 'mini'">
      <!-- note: don't add a linebreak between these two spans! -->
      <span class="text-salmon text-md font-bold">${{ dollar }}.{{ cents }}</span><span class="text-navy text-sm">{{ miniSubtext }}</span>
    </div>

    <!-- default version -->
    <div v-else>
      <div class="flex flex-col items-center gap-2">
        <slot name="eyebrow" />
        <div class="relative flex flex-row justify-center items-stretch gap-1">
          <div
            class="relative text-salmon tracking-tighter flex flex-row items-start gap-0.5"
            :class="grayscale">
            <span
              class="font-bold"
              :style="{ fontSize: '2rem', lineHeight: 1 }">$</span>
            <span
              class="font-heavy text-6xl"
              :style="{ lineHeight: 0.8 }">{{ dollar }}</span>
          </div>

          <div
            class="flex flex-col leading-none"
            :class="(recurring && unit) ? 'justify-between' : 'justify-start'">
            <div
              class="text-base text-salmon font-bold"
              :class="grayscale">
              {{ cents }}<template v-if="showAsterisk">*</template>
            </div>
            <div
              class="font-bold text-navy"
              :style="{ fontSize: '.78rem' }"
              :class="grayscale">
              {{ recurring }}
            </div>
            <div
              class="font-bold text-navy"
              :style="{ fontSize: '.78rem' }"
              :class="grayscale">
              {{ unit }}
            </div>
            <span
              v-if="variant == 'crossedOut'"
              class="absolute top-1/2 right-0 left-0 origin-center h-2 border-salmon bg-salmon"
              :style="{ width: '110%', transform: 'rotate(-18deg) translateX(-2.5%)' }" />
          </div>
        </div>
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BusinessPricePerMonth',
    props: {
      price: {
        type: Number,
        required: false,
      },
      recurring: {
        type: String,
        required: false,
        default: '/mo',
      },
      unit: {
        type: String,
        required: false,
        default: 'each',
      },
      showAsterisk: {
        type: Boolean,
        required: false,
        default: false,
      },
      variant: {
        type: String,
        required: false,
        default: 'default',
        validator: (val) => ['default', 'crossedOut', 'mini'].includes(val),
      },
    },
    computed: {
      normalizedPrice() {
        return this.price.toFixed(2).split('.')
      },
      dollar() {
        return this.normalizedPrice[0]
      },
      cents() {
        return this.normalizedPrice[1]
      },
      grayscale() {
        return {
          default: ``,
          crossedOut: `filter grayscale`,
        }[this.variant]
      },
      miniSubtext() {
        let subtext = ''

        if (this.recurring.length) {
          subtext += `${this.recurring}`
        }

        if (this.unit.length) {
          subtext += ` ${this.unit}`
        }

        if (this.showAsterisk) {
          subtext += '*'
        }

        return subtext
      },
    },
    methods: {
          setTerms(terms) {
            this.$emit("term-click", terms);
        },
      }
  }
</script>

